import React from "react";

export default function OutlinedSelect({
  label,
  value,
  onChange,
  options,
  minWidth = 180,
}) {
  return (
    <fieldset
      style={{
        border: "1px solid #ccc",
        borderRadius: 6,
        padding: "6px 10px 8px",
        minWidth,
      }}
    >
      <legend
        style={{
          padding: "0 6px",
          fontSize: "12px",
          fontWeight: 500,
          color: "#000",
        }}
      >
        {label}
      </legend>

      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          background: "transparent",
          color: "#000",
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        {options.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
            style={{ color: "#000" }}
          >
            {opt.label}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
